import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS, Apollo} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {ApolloLink, InMemoryCache} from '@apollo/client/core';
import {onError} from '@apollo/client/link/error';
import {map} from 'rxjs/operators';
import {environment} from "../../environments/environment";


const uri = environment.CART_GATEWAY_URL;

const defaultOptions: any = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        // This is to prevent the Apollo client from emitting loading states. 
        // WatchQuery now returns loading states and messes up the take(1) operator that we have everywhere.
        // We should change most of these watchQuery to query to avoid this issue in the future.
        notifyOnNetworkStatusChange: false
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
    },
    mutate: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
    }
};

export const provideApollo = (httpLink: HttpLink) => {
    const http = httpLink.create({uri});

    const error = onError(({graphQLErrors, networkError}: any) => {
        if (graphQLErrors) {
            graphQLErrors.forEach(({message}: any) => {
                console.log(`[GraphQL error]: ${message}`);
            });
        }
        if (networkError) {
            console.log(`[Network error]: ${networkError}`);
        }
    });

    const cleanTypeName = new ApolloLink((operation, forward) => {
        const omitTypeName = (key: string, value: any) => (key === '__typename' ? undefined : value);
        const stripTypeName = (rawValue: any) => JSON.parse(JSON.stringify(rawValue), omitTypeName);
        if (operation.variables) {
            operation.variables = stripTypeName(operation.variables);
        }
        return forward(operation).pipe(
            map((data) => stripTypeName(data))
        );
    });

    // http must be concat'd last
    const link = ApolloLink.from([cleanTypeName, error, http]);
    const cache = new InMemoryCache();
    return {
        link,
        cache,
        defaultOptions
    };
};

@NgModule({ providers: [
        Apollo,
        {
            provide: APOLLO_OPTIONS,
            useFactory: provideApollo,
            deps: [HttpLink],
        }
    ] })
export class GraphQLModule {
}
